import React from 'react';
import PropTypes from 'prop-types';
import Paper from '../Paper';
import Avatar from '../Avatar';
import Rating from '../Rating';
import Typography from '../Typography';
import IconButton from '../IconButton';
import Icon from '../Icon';
import useTheme from '../../hooks/useTheme';
import { StyledUser, StyledIconButtonWrapper, StyledRatingWrapper, StyledTypographyWrapper } from './styled';
import { makeStyles } from '../../utils/styles';
import Box from '../Box';
import { getShortcutUsername } from '../../utils/helpers';

const useStyles = makeStyles(css => ({
    paper: css`
        padding: 6px 10px;
        border-radius: 20px;
    `,
    boxRating: css`
        margin-left: 40px;
        line-height: 1.2em;
    `
}));

const User = ({ user, interactive, showRating, showShortcut, hideDelete, onClickDelete }) => {
    const theme = useTheme();
    const styles = useStyles();

    const handleClickDelete = id => () => onClickDelete && onClickDelete(id);

    return (
        <StyledUser
            interactive={interactive}
        >
            <Avatar
                src={user?.avatarSrc}
                alt={user?.avatarAlt}
                size={interactive ? "large" : "medium"}
                shortcut={showShortcut ? getShortcutUsername(user?.name, user?.surname) : ""}
            />
            {
                (interactive && !hideDelete) &&
                <StyledIconButtonWrapper>
                    <IconButton
                        size="small"
                        backgroundColor={theme.colors.steelBlue}
                        onClick={handleClickDelete(user?.id)}
                    >
                        <Icon
                            name="delete"
                            width="12px"
                            height="12px"
                            fill={theme.colors.white}
                        />
                    </IconButton>
                </StyledIconButtonWrapper>
            }
            {
                interactive &&
                <StyledRatingWrapper>
                    <Paper
                        inline
                        customStyle={styles.paper}
                    >
                        <Rating rate={user?.rating} />
                    </Paper>
                </StyledRatingWrapper>
            }
            <StyledTypographyWrapper
                showRating={showRating}
            >
                {
                    interactive && user?.name &&
                    <Typography as="h2">
                        {user.name}
                    </Typography>
                }
                {
                    interactive && user?.surname &&
                    <Typography as="h2">
                        {user.surname}
                    </Typography>
                }
                {
                    !interactive &&
                    <Typography as="h2">
                        {user?.name} {user?.surname}
                    </Typography>
                }
                {
                    !interactive && showRating &&
                    <Box customStyle={styles.boxRating}>
                        <Rating rate={user?.rating} />
                    </Box>
                }
            </StyledTypographyWrapper>
        </StyledUser>
    );
};

User.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
        avatarSrc: PropTypes.string,
        avatarAlt: PropTypes.string,
        rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        surname: PropTypes.string
    }),
    interactive: PropTypes.bool,
    showRating: PropTypes.bool,
    showShortcut: PropTypes.bool,
    hideDelete: PropTypes.bool,
    onClickDelete: PropTypes.func
};

User.defaultProps = {
    interactive: false,
    showRating: false,
    onClickDelete: undefined
};

export default React.memo(User);
